module.exports = __webpack_public_path__ + "static/media/social_feed.ce7f0180.png";